import { Component, OnInit  } from '@angular/core';

async function backend_tester_fn() {
  if (window.location.pathname == "/") {
  window.location.href = '/connecter' ;}} ;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Gestion des Employés';

  ngOnInit(): void {
    backend_tester_fn() ;
  }



}

